import React from "react";
import {
  ListingNavbar,
  TitleBar,
  IconBar,
  StyledContainer,
  FullSummary,
  MobileSummary,
  GalleryBar,
  Details,
  Videos,
  VirtualOpenHouse,
  AgentInfo,
  Footer,
  Floorplan,
  Photos,
  VirtualTour,
  ScrollToTop,
} from "../components";
import { useStateContext as useListingState } from "../context/ListingContext";
import useWindowSize from "../hooks/useWindowSize";
import styled from "styled-components";
import "flickity-fullscreen";

const TopInfoWrapper = styled.div`
  position: relative;
`;

const ListingPage = () => {
  const { isLarge } = useWindowSize();
  const { success, listing } = useListingState();
  if (!success) return null;
  return (
    <div id="ListingPage">
      <ListingNavbar />
      <TopInfoWrapper>
        <TitleBar />
        {!isLarge && <MobileSummary listing={listing} />}
        <GalleryBar />
        {!isLarge && <Photos type="Photos" />}
        <StyledContainer>
          <FullSummary />
          <IconBar />
        </StyledContainer>
      </TopInfoWrapper>
      {isLarge && <Photos type="Photos" />}
      <Details />
      <VirtualOpenHouse />
      <Floorplan />
      <Videos />
      <VirtualTour />
      <AgentInfo />
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default ListingPage;
